import type { ComputedRef, InjectionKey } from 'vue'
import type { KControlSize } from '../../types'

export interface KCheckboxGroupContext {
    disabled: ComputedRef<boolean>
    invalid: ComputedRef<boolean>
    size: ComputedRef<KControlSize>
}

export const K_CHECKBOX_GROUP_CONTEXT = Symbol('KCheckboxGroup') as InjectionKey<KCheckboxGroupContext>
